import { memo } from 'react';

interface HeaderProps {
  onScrollToOffer: () => void;
}

const Header = memo(({ onScrollToOffer }: HeaderProps) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-yellow-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-lg flex items-center justify-center">
            <i className="ri-key-2-line text-black text-lg sm:text-xl"></i>
          </div>
          <span className="text-yellow-400 font-bold text-sm sm:text-base" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            O CÓDIGO
          </span>
        </div>
        
        <button 
          onClick={onScrollToOffer}
          className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-black px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-bold hover:from-yellow-500 hover:to-yellow-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          QUERO O EBOOK
        </button>
      </div>
    </header>
  );
});

Header.displayName = 'Header';

export default Header;
